export function App(): JSX.Element {
  return (
    <main>
      <h1>DineRate · Super-Admin</h1>
      <p>Onboard and manage merchants. Implementation lands in Phase 4.</p>
      <footer><small>Maintained by Blake and team, with Kevin and Ben</small></footer>
    </main>
  );
}
